import { doc, setDoc, getDoc } from "firebase/firestore";
import { db } from "../firebase"; // Your Firebase configuration
import { collection, getDocs } from "firebase/firestore";

class ChallengeEntry {
  constructor(userId, challengeId, date, value) {
    this.userId = userId;
    this.challengeId = challengeId;
    this.date = date; // Format: YYYY-MM-DD
    this.value = value;
    this.time = new Date().toISOString(); // Timestamp for the log
  }

  // Helper to get the Firestore document path
  static getProgressPath(userId, challengeId, date) {
    return `progress/${userId}/${challengeId}/${date}`;
  }

  

  // Save or update the entry in Firestore
  static async save(entry) {
    const progressPath = ChallengeEntry.getProgressPath(
      entry.userId,
      entry.challengeId,
      entry.date
    );
    
    const progressRef = doc(db, progressPath);
    const progressDoc = await getDoc(progressRef);
    if (progressDoc.exists()) {
      // Update existing progress
      const progressData = progressDoc.data();

      // Update total and append log
      const updatedTotal = (progressData.total || 0) + entry.value;
      const updatedLogs = [
        ...(progressData.logs || []),
        { time: entry.time, value: entry.value },
      ];

      await setDoc(progressRef, {
        total: updatedTotal,
        logs: updatedLogs,
      });
    } else {
      // Create new progress entry
      console.log({entry})
      await setDoc(progressRef, {
        total: entry.value,
        logs: [{ time: entry.time, value: entry.value }],
      });
    }
  }

  static getChallengeEntryCount = async (userId, challengeWebSafeName) => {
    try {
      // Reference to the collection of dates for the challenge
      const datesRef = collection(db, `progress/${userId}/${challengeWebSafeName}`);
      const snapshot = await getDocs(datesRef);

      let totalEntries = 0;
      let todayEntries = 0;

      const today = new Date().toISOString().split('T')[0];
      const currentYear = new Date().getFullYear();
      const yearStart = `${currentYear}-01-01`;

      // Iterate over each date document, only counting entries from Jan 1st of current year
      snapshot.forEach((doc) => {
        const data = doc.data();
        console.log({id: doc.id, today})

        // Only count entries from current year (doc.id is in YYYY-MM-DD format)
        if (doc.id >= yearStart) {
          if (doc.id === today) {
            todayEntries = data.total;
          }
          totalEntries += data.total;
        }
      });

      return [totalEntries, todayEntries];
    } catch (error) {
      console.error("Error fetching challenge entries:", error);
      return [0, 0];
    }
  }

  // Fetch progress for a specific user and challenge
    static async fetchProgress(userId, challengeId) {
        const progressRef = doc(db, `progress/${userId}/${challengeId}`);
        const progressDoc = await getDoc(progressRef);
        return progressDoc.exists() ? progressDoc.data() : null;
    }

    
   // Fetch all challenges for a user
    static async fetchChallenges(userId) {
        const challengesRef = collection(db, `challenges/${userId}/tasks`);
        const snapshot = await getDocs(challengesRef);
        return snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
    }
}

export default ChallengeEntry;
